var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row h-20 p-4 items-start",attrs:{"id":"nav"}},[_c('img',{staticClass:"h-full",attrs:{"src":require("../assets/logo.png")}}),_c('Socials',{staticClass:"flex-1 justify-end h-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }